export default "/profile/images/KommoCRM.svg?aea586a45b1a06649256fcb22aad1b25";